import type { SharedApiV2 } from "@capstone/mock-api";
import { getApiDetailsDecorator } from "src/utils";

const api = getApiDetailsDecorator<
  SharedApiV2.PostDoorDto | SharedApiV2.PatchDoorDto
>();
export abstract class BaseDoor {
  protected constructor(args: ClassProperties<BaseDoor>) {
    this.displaySequence = args.displaySequence;
    this.maxUnitCount = args.maxUnitCount;
    this.minUnitCount = args.minUnitCount;
    this.name = args.name;
    this.physicalSequence = args.physicalSequence;
  }

  @api({ key: "sortOrder" }) public readonly displaySequence: number;
  @api({ key: "maxUnitCount" }) public readonly maxUnitCount: number;
  @api({ key: "minUnitCount" }) public readonly minUnitCount: number;
  @api() public readonly name: string;
  @api({ key: "sequence" }) public readonly physicalSequence: number;
}
